import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTotalDuration } from 'modules/App/hooks/useTotalDuration';
import { TimeSignal } from 'graphql/types';
import { useFormattedDuration } from 'modules/notes/common';

const useStyles = makeStyles((theme) => ({
  duration: {
    fontSize: theme.typography.subtitle1.fontSize,
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));

interface NotesTotalDurationProps {
  notes: TimeSignal[];
}

export const useGlobalDuration = ({
  notes
}: NotesTotalDurationProps): number => {
  const { control } = useFormContext();
  const values = useWatch({
    control
  });
  const selectedNotes = useMemo(
    () => notes.filter((note) => values[`${note.date}_${note.id}`]),
    [notes, values]
  );

  const totalDuration = useTotalDuration(selectedNotes);

  return totalDuration;
};

export const NotesTotalDuration: React.FC<NotesTotalDurationProps> = ({
  notes
}: NotesTotalDurationProps) => {
  const classes = useStyles();

  const totalDuration = useGlobalDuration({ notes });

  const formattedDuration = useFormattedDuration({
    needsMask: true,
    duration: totalDuration ?? 0
  });

  return (
    <Typography
      data-testid="totalTimeFromDurationLabels"
      className={classes.duration}
    >
      {formattedDuration}
    </Typography>
  );
};
